<app-section #parentSection
             [formConfig]="formConfig"
             [sectionRef]="section"
             [key]="key"
             [formGroup]="formGroup"
             [title]="title">

  <ng-template #section>

    <mat-radio-group [formControl]="control"
                     (click)="onClick()">
      <div class="payments-container">
        <div *ngIf="methodPaymentsService.isMethodAllowed(PaymentMethod.BLIK_ONLINE)" class="payments-box">
          <mat-radio-button class="payments-radio" [value]="PaymentMethod.BLIK_ONLINE">{{ "METHOD_PAYMENT_SECTION.blikOnline" | translate }}</mat-radio-button>
          <div class="payments-image-container">
            <img class="payments-image" src="./assets/images/payments-bank.png" />
            <img class="payments-image payments-image--przelewy-24" src="./assets/images/przelewy-24.svg" />
          </div>
        </div>

        <div *ngIf="methodPaymentsService.isMethodAllowed(PaymentMethod.CARD)" class="payments-box">
          <mat-radio-button class="payments-radio" [value]="PaymentMethod.CARD">{{ "METHOD_PAYMENT_SECTION.card" | translate }}</mat-radio-button>
          <div class="payments-image-container">
            <img class="payments-image max-height-20" src="./assets/images/payments-card.png" />
            <img class="payments-image payments-image--przelewy-24" src="./assets/images/przelewy-24.svg" />
          </div>
        </div>

        <div *ngIf="methodPaymentsService.isMethodAllowed(PaymentMethod.MPAY)" class="payments-box">
          <mat-radio-button class="payments-radio" [value]="PaymentMethod.MPAY">{{ "METHOD_PAYMENT_SECTION.mpay" | translate }}</mat-radio-button>
          <div class="payments-image-container">
            <img class="payments-image width-90" src="./assets/images/mpay-payment.svg" />
          </div>
          <div *ngIf="methodPaymentsService.displayPaymentsDescription" class="payments-description">
            {{ 'METHOD_PAYMENT_SECTION.mpayDescription' | translate }}
          </div>
        </div>

        <div *ngIf="methodPaymentsService.isMethodAllowed(PaymentMethod.SKYCASH)" class="payments-box">
          <mat-radio-button class="payments-radio" [value]="PaymentMethod.SKYCASH">{{ "METHOD_PAYMENT_SECTION.skycash" | translate }}</mat-radio-button>
          <div class="payments-image-container">
            <img class="payments-image width-90" src="./assets/images/mpay-payment.svg" />
          </div>
          <div *ngIf="methodPaymentsService.displayPaymentsDescription" class="payments-description">
            {{ 'METHOD_PAYMENT_SECTION.skycashDescription' | translate }}
          </div>
        </div>

        <div *ngIf="methodPaymentsService.isMethodAllowed(PaymentMethod.STANDARD_TRANSFER)" class="payments-box">
          <mat-radio-button class="payments-radio" [value]="PaymentMethod.STANDARD_TRANSFER">{{ "METHOD_PAYMENT_SECTION.standardTransfer" | translate }}</mat-radio-button>
          <div class="payments-image-container">
            <img class="payments-image" src="./assets/images/przelew-tradycyjny.jpg" />
          </div>
          <div *ngIf="methodPaymentsService.displayPaymentsDescription" class="payments-description">
            {{ 'METHOD_PAYMENT_SECTION.standardTransferDescription' | translate }}
          </div>
        </div>
      </div>
    </mat-radio-group>

    <div class="payments-info-container">
      <div>
        {{ contractInfo | translate }}
      </div>
    </div>


    <mat-error *ngIf="isError" class="radio-error">{{ errorMessage |translate}}</mat-error>
  </ng-template>

</app-section>
